// extracted by mini-css-extract-plugin
export default {"progressIcon":"styles_progressIcon__9aFMA"};